

var BtnReserve = {
  init(){
    this.btn = $('.fnc-btnEntry');
    this.cnts = $('.l-contents');
    this.device = 'pc';
    this.timer;

    this.cnts.css({
      paddingBottom: this.btn.outerHeight() + 20
    });


    if( !window.matchMedia('(min-width: 768px)').matches ){
      this.device = 'sp;'
      this.setSp();
    }



    this.showBtn();
    this.event();



  },
  setSp(){

    this.btn.css({
      position: 'absolute',
      height: this.btn.outerHeight(),
      top: this.cnts.outerHeight() + this.cnts.offset().top - this.btn.outerHeight(),
      bottom: 'inherit'
    });



  },
  event(){
    $(window).on('touchstart.reserve', ()=>{


    });

    $(window).on('scroll.reserve', ()=>{
      
      if( window.matchMedia('(min-width: 768px)').matches ){
        this.checkPos();
      }

    });

    $(window).on('resize.reserve', ()=>{


      this.cnts.css({
        paddingBottom: this.btn.outerHeight() + 20
      });


      if( !window.matchMedia('(min-width: 768px)').matches ){
        this.btn.removeAttr('style');
        this.setSp();
      }else{
        this.btn.removeAttr('style');
        TweenMax.set(this.btn , {opacity: 1});
      }

    });
  },
  showBtn(){
    TweenMax.set(this.btn , {bottom: -this.btn.outerHeight()});
    if( window.matchMedia('(min-width: 768px)').matches ){
      TweenMax.to(this.btn, 0.5,{ ease: Power4.easeOut,  bottom:0, opacity: 1});
    }
  },
  checkPos(){
    if( $(window).scrollTop() + $(window).height() > this.cnts.outerHeight() + this.cnts.offset().top ){
      this.btn.addClass('is-fixed');
      this.btn.css({
        position: 'absolute',
        top: this.cnts.outerHeight() + this.cnts.offset().top - this.btn.outerHeight(),
        bottom: 'inherit'
      });
    }else{
      this.btn.removeClass('is-fixed');
      this.btn.css({
        position: 'fixed',
        top: 'inherit',
        bottom: 0
      });
    }
  }
}

module.exports = BtnReserve;


// WEBPACK FOOTER //
// ./src/js/fncs/BtnEntry.js